exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expiration_text[data-v-b465be9e]{font-size:14px;font-weight:300}.expired[data-v-b465be9e]{position:relative}.expired_text[data-v-b465be9e]{position:absolute;bottom:-9px;z-index:3;font-size:10px;font-weight:300}[data-v-b465be9e] .v-list__tile{height:auto}", ""]);

// exports
